// src/components/common/StatusBadge.jsx
// -----------------------------------------------------------------------------
// Colored chip used to display ticket Status / Severity / Role / user Status
// values consistently. Maps common words to a badge color; falls back to the
// neutral/info color for anything not in the map (project-specific values are
// configurable per Requirement #16 & #17, so we can't hard-code every option).
// -----------------------------------------------------------------------------
import PropTypes from 'prop-types';
import './common.css';

const COLOR_MAP = {
  // Ticket status style values
  open: 'info',
  new: 'info',
  'in progress': 'warning',
  reopened: 'warning',
  resolved: 'success',
  closed: 'success',
  // Severity style values
  critical: 'danger',
  high: 'danger',
  medium: 'warning',
  low: 'info',
  // Generic status values
  active: 'success',
  inactive: 'danger',
  locked: 'danger',
  archived: 'info',
};

export default function StatusBadge({ value }) {
  if (!value) return null;
  const key = String(value).toLowerCase();
  const variant = COLOR_MAP[key] || 'info';
  return <span className={`badge badge-${variant}`}>{value}</span>;
}

StatusBadge.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};